export default subscription => ['company', 'self'].includes(subscription.subscription_type) && !!subscription.employee_emails
